module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-book-webfont.a2979a45.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-book-webfont.woff
// module id = 371
// module chunks = 3